// Consolidate Loan state update logic.
export default (state, action) => {
    switch (action.type) {
        case 'SET_LOAN_PRODUCTS':
            return {
                ...state,
                loanProducts: [action.payload, state.loanProducts]
            }
        case 'SET_LOAN_PRODUCT':
            return {
                ...state,
                loanProduct: [action.payload, state.loanProduct]
            }
        case 'SET_LOAN_CHILD_TYPE':
            return {
                ...state,
                loanChildType: [action.payload, state.loanChildType]
            }
        case 'SET_LOAN_TYPE':
            return {
                ...state,
                loanType: [action.payload, state.loanType]
            }
        case 'SET_LOAN_DETAILS':
            return {
                ...state,
                loanDetails: [action.payload, state.loanDetails]
            }
        case 'SET_CLIENT_DETAILS':
            return {
                ...state,
                clientDetails: [action.payload, state.clientDetails]
            }
        case 'SET_ERROR':
            return {
                ...state,
                error: [action.payload, state.error]
            }
        case 'SET_LOADING':
            return {
                ...state,
                loading: [action.payload, state.loading]
            }

        default:
            return state;
    }
}